import React from "react";
import Addresses from "../home/components/Addresses";
import { MessageForm } from "../home/components/MessageForm";

const Contacts = () => {
  return (
    <div>
      <Addresses />
      <MessageForm />
    </div>
  );
};

export default Contacts;
